import { ProductListingTypes } from "./product";

export const listingTypeOptions = [
	{
		header: "Containerized Application",
		value: ProductListingTypes.ContainerStack,
		body: "Containerized software that can be deployed and managed with operators or Helm charts and be run on Red Hat products",
		checked: true,
	},
	{
		header: "Standalone Application",
		value: ProductListingTypes.TraditionalApplication,
		body: "Non-containerized software that can be installed to run on Red Hat products",
		checked: false,
	},
	{
		header: "OpenStack Infrastructure",
		value: ProductListingTypes.OpenStackInfrastructure,
		body: "Software that can be installed to run on the Red Hat OpenStack platform",
		checked: false,
	},
];

export enum DeployedAsTypeValues {
	helmChart = "Helm chart",
	operator = "Operator",
}

export const DeployedAsTypeNames: Record<string, string> = {
	[DeployedAsTypeValues.operator]: "OpenShift Operator",
	[DeployedAsTypeValues.helmChart]: "Helm Chart",
};

export const ProductListFilters = {
	name: "productType",
	label: "Product Type",
	className: "product-list-dropdown-item pf-select-wrapper",
	options: [
		{ text: "All Types", value: "All" },
		...Object.keys(DeployedAsTypeNames).map((key) => ({ text: DeployedAsTypeNames[key], value: key })),
		...listingTypeOptions.map((item) => {
			return { text: item.header, value: item.value };
		}),
	],
};
